import React from 'react';
import SignOut from './SignOut';
const SignOutS = ({ color, ...props }) => (React.createElement(SignOut, Object.assign({ color: color, size: 24 }, props)));
SignOutS.displayName = 'SignOutS'; // Fix for tsc
export default SignOutS;
//# sourceMappingURL=SignOutS.js.map